export default () => {
  // Remaining character counter for text area
  $('#InhouseContactForm textarea[name=contact_message]').on(
    'input',
    function () {
      let maxlength = Number($(this).attr('maxlength'));
      let currentLength: number = ($(this).val() as string).length;

      const currentEl = $('#inhouse-training-modal-dialog-char-counter');

      currentEl.text(currentLength);
      if (currentLength >= maxlength) {
        currentEl.css('color', '#dc3545');
      } else {
        currentEl.css('color', '#212529');
      }
    }
  );
};
